import { render, staticRenderFns } from "./ticketSupportDetail.vue?vue&type=template&id=31d5b619&scoped=true&"
import script from "./ticketSupportDetail.vue?vue&type=script&lang=js&"
export * from "./ticketSupportDetail.vue?vue&type=script&lang=js&"
import style0 from "./ticketSupportDetail.vue?vue&type=style&index=0&id=31d5b619&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d5b619",
  null
  
)

export default component.exports